<svg [class.me-2]="position === 'left'" [class.ms-2]="position === 'right'"
  xmlns='http://www.w3.org/2000/svg'
  width='23' height='24' viewBox='0 1 23 24' fill='none'>
  <path d="M7.48053 9.84686H2.98053V5.34686" stroke="white" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M17.8305 6.66873C17.0652 5.90224 16.1562 5.29417 15.1556 4.87929C14.155 4.4644 13.0825 4.25085 11.9993 4.25085C10.9161 4.25085 9.84353 4.4644 8.84295 4.87929C7.84237 5.29417 6.9334 5.90224 6.16803 6.66873L2.98053 9.84685"
    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M16.5196 15.1531H21.0196V19.6531" stroke="white" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M6.16803 18.3313C6.9334 19.0977 7.84237 19.7058 8.84295 20.1207C9.84353 20.5356 10.9161 20.7491 11.9993 20.7491C13.0825 20.7491 14.155 20.5356 15.1556 20.1207C16.1562 19.7058 17.0652 19.0977 17.8305 18.3313L21.018 15.1531"
    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>